export const getIconSvg = (iconName:  string, pathToResource = 'icons', ext = 'svg'): string => `./assets/${pathToResource}/${iconName.toLowerCase()}.${ext}`;
